export default "__VITE_ASSET__BKsWrpnB__$_?no-inline__"